import { createContext, useContext, useState, useEffect, useMemo } from "react";

const DICT = {
  en: {
    // brand / chrome
    brandSub: "Wholesale Portal",
    dealerPortal: "Dealer Portal",
    adminConsole: "Admin Console",
    // welcome / hero
    heroBadge: "Licence-verified dealers only",
    heroTitle: "West Bengal's wholesale fertilizer ordering portal",
    heroSub: "M/S Sabuj Sona Fertilizer supplies Urea, DAP, Potash and more to licensed dealers across the state. Place company-wise wholesale orders, track dispatch and manage payments — all from one portal.",
    howTitle: "How ordering works",
    how1: "Login with your registered dealer mobile number.",
    how2: "Pick a company, choose products and enter quantity in KG, Metric Ton or Truck.",
    how3: "Confirm the order with your preferred delivery date — the company is notified instantly.",
    how4: "Track approval, dispatch vehicle and payments in Order History.",
    feature1Title: "All major companies",
    feature1Sub: "IFFCO, IPL, Indorama, Coromandel and more — stock managed live by the company.",
    feature2Title: "Transparent wholesale rates",
    feature2Sub: "See the current rate per Metric Ton, or request a call for the latest quote.",
    feature3Title: "Dispatch you can track",
    feature3Sub: "Vehicle number, dispatch date and delivery status shared on every confirmed order.",
    footerNote: "Wholesale fertilizer distribution · West Bengal",
    // business profile
    bpTitle: "Business Profile",
    bpSub: "An established, licensed wholesale fertilizer business serving dealers across Cooch Behar and West Bengal.",
    bpWhoTitle: "Licensed wholesale fertilizer dealer",
    bpWhoText: "M/S Sabuj Sona Fertilizer is a proprietorship business owned by Sonali Das Barman, authorised to wholesale fertilizers to retail dealers. We stock Urea, DAP, MOP/Potash, SSP and complex fertilizers from all major companies and dispatch across the district.",
    legalName: "Legal Name",
    tradeName: "Trade Name",
    businessType: "Business Type",
    proprietorship: "Proprietorship",
    businessCategory: "Business Category",
    wholesaleDealer: "Wholesale Fertilizer Dealer",
    licenseNo: "Fertilizer License / Authorization No.",
    udyamNo: "Udyam Registration No.",
    gstin: "GSTIN",
    storeAddress: "Store Address",
    trustNote: "Deal with confidence — our licence, Udyam registration and GSTIN are public and verifiable.",
    // contact
    contactTitle: "Contact Us",
    contactSub: "Call now for today's rates, stock availability and orders.",
    callNow: "Call Now",
    visitStore: "Visit the store",
    // auth / login
    welcomeBack: "Welcome back",
    howWouldYouLike: "How would you like to login?",
    loginWithOtp: "Login with OTP",
    loginWithPassword: "Login with Password",
    useDifferentNumber: "Use a different number",
    loginContinue: "Login / Continue",
    loginCardSub: "Enter your mobile number. Admin and dealer accounts are detected automatically.",
    continue: "CONTINUE",
    newCustomer: "New customer?",
    createDealerAccount: "Create dealer account",
    verifyMobile: "Verify Mobile",
    otpSentTo: "OTP sent to",
    adminPinLabel: "Admin Security PIN (6-digit)",
    loginAsAdmin: "Login as Admin",
    verifyLogin: "Verify & Login",
    resendOtp: "Resend OTP",
    changeNumber: "Change number",
    notRegisteredYet: "Not registered yet",
    notRegisteredSub: "The mobile number {m} does not have an account. Create a dealer account to start ordering.",
    createAccount: "Create Account",
    becomeDealer: "Become a dealer",
    password: "Password",
    login: "Login",
    useOtpInstead: "Use OTP instead",
    // register
    registerTitle: "Create Dealer Account",
    registerSub: "Register your business to place wholesale fertilizer orders.",
    backToLogin: "Back to login",
    customerName: "Customer / Business Name",
    licensePh: "WB/FL/XXXXXX",
    posIdOptional: "POS ID (optional)",
    passwordOptional: "Password (optional — enables password login)",
    passwordPh: "Min 6 characters",
    addressLabel: "Shop / Delivery Address",
    addressPh: "Village, Post Office, District, PIN",
    photoLabel: "Customer Photo / Selfie",
    photoHint: "Upload a photo or selfie (JPG/PNG, max 15 MB)",
    choosePhoto: "Choose Photo",
    uploading: "Uploading...",
    sendOtpContinue: "Send OTP & Continue",
    sendingOtp: "Sending OTP...",
    creatingAccount: "Creating account...",
    // customer portal
    dashboard: "Dashboard",
    dashboardSubtitle: "Overview of your wholesale orders and payments.",
    fertilizer: "Fertilizer",
    pesticide: "Pesticide",
    myOrders: "My Orders",
    profile: "Profile",
    logout: "Logout",
    comingSoon: "Coming Soon",
    pendingApproval: "Pending Approval",
    activeConfirmed: "Active / Confirmed",
    completed: "Completed",
    outstandingDue: "Outstanding Due",
    quickOrderFertilizer: "Quick Order — Fertilizer",
    quickOrderFertilizerSub: "Order Urea, DAP, Potash & more",
    quickOrderPesticide: "Quick Order — Pesticide",
    quickOrderPesticideSub: "Pesticide ordering launches shortly",
    recentOrders: "Recent Orders",
    viewAll: "View all",
    selectCompany: "Fertilizer — Select Company",
    selectCompanySub: "Choose a company to view available products and stock.",
    viewProducts: "View products →",
    noCompanies: "No companies available right now.",
    allCompanies: "All companies",
    products: "Products",
    searchFertilizer: "Search fertilizer...",
    product: "Product",
    availableStock: "Available Stock",
    ratePerMt: "Rate (per MT)",
    action: "Action",
    outOfStock: "Out of stock",
    callForRate: "Call for rate",
    add: "Add",
    addQuantity: "Add Quantity",
    available: "Available",
    quantity: "Quantity",
    unit: "Unit",
    kg: "KG",
    metricTon: "Metric Ton",
    truck: "Truck",
    lineTotal: "Line total",
    addToOrder: "Add to Order",
    cancel: "Cancel",
    productsInOrder: "product(s) in order",
    viewRemove: "View / Remove",
    hide: "Hide",
    reviewOrder: "Review Order",
    orderReview: "Order Review",
    orderReviewSub: "Review your wholesale order. You can adjust quantity or remove products.",
    requestedQty: "Requested",
    approved: "Approved",
    amount: "Amount",
    proceedConfirm: "Proceed to Final Confirmation →",
    finalConfirmation: "Final Confirmation",
    productLines: "product line(s) · Please verify before placing the order.",
    deliveryRequiredDate: "Delivery Required Date",
    note: "Note",
    orderTotal: "Order Total (priced lines)",
    noGstNote: "No GST / invoice in this confirmation",
    back: "Back",
    confirmOrder: "Confirm Order",
    placingOrder: "Placing order...",
    orderPlacedSuccess: "Order Placed Successfully",
    placedMsg: "A confirmation has been sent to your registered mobile. Current status:",
    viewMyOrders: "View My Orders",
    newOrder: "New Order",
    emptyOrder: "Your order is empty",
    emptyOrderSub: "Add fertilizer products to place an order.",
    browseFertilizer: "Browse Fertilizer",
    myOrdersTitle: "My Orders",
    myOrdersSub: "All your current and previous wholesale orders.",
    orderNo: "Order No",
    date: "Date",
    total: "Total",
    paid: "Paid",
    due: "Due",
    payment: "Payment",
    deliveryDate: "Delivery Date",
    status: "Status",
    statusMethod: "Status / Method",
    view: "View",
    cancelOrder: "Cancel Order",
    payOnline: "Pay Online",
    deliveryDispatch: "Delivery / Dispatch",
    vehicleNumber: "Vehicle number",
    driver: "Driver",
    orderTimeline: "Order Timeline",
    ratePending: "Rate pending",
    profileTitle: "Profile",
    profileSub: "Your registered dealer information.",
    editProfile: "Edit Profile",
    name: "Name",
    mobileNumber: "Mobile Number",
    addressLabelC: "Address",
    posId: "POS ID Number",
    licenceNumber: "Licence Number",
    newPhotoReady: "New photo ready — save to apply",
    changePhoto: "Change Photo",
    newPassword: "New Password (leave blank to keep current)",
    saveChanges: "Save Changes",
    profileUpdated: "Profile updated",
    // admin console
    adminDashboardTitle: "Admin Dashboard",
    adminDashboardSub: "Operational overview of orders, customers and dispatch.",
    newOrders: "New Orders",
    customers: "Customers",
    dispatch: "Dispatch",
    confirmedLabel: "Confirmed",
    deliveredLabel: "Delivered",
    cancelledLabel: "Cancelled",
    totalDue: "Total Due",
    latestOrders: "Latest Orders",
    orders: "Orders",
    productsStock: "Products & Stock",
    dailyRecords: "Daily Records",
    annualReturns: "Annual Returns",
    notifSettings: "Notification Settings",
    adminAccounts: "Admin Accounts",
    notifications: "Notifications",
    settings: "Settings",
    adminOrdersTitle: "Orders",
    adminOrdersSub: "Review, approve and manage incoming wholesale orders.",
    searchOrders: "Search order no / customer...",
    filterAll: "All",
    filterOpen: "Open",
    customerLbl: "Customer",
    mobileLbl: "Mobile",
    reviewTitle: "Order Items — review, approve, modify or cancel",
    preferredDelivery: "Preferred Delivery",
    customerNote: "Customer Note",
    ratePerMtShort: "Rate / MT",
    lineStatus: "Line Status",
    actions: "Actions",
    approve: "Approve",
    modify: "Modify",
    paymentsTitle: "Payments",
    recordPayment: "Record Payment",
    amountRupee: "Amount ₹",
    refTxn: "Ref / Txn ID",
    noPaymentsYet: "No payment records yet.",
    deliveryDispatchAdmin: "Delivery & Dispatch",
    deliveryDateField: "Delivery Date",
    driverName: "Driver Name",
    driverPhone: "Driver Phone",
    dispatchStatus: "Dispatch Status",
    notes: "Notes",
    saveDelivery: "Save Delivery Information",
    activityTimeline: "Activity Timeline",
    by: "by",
    acceptedBy: "Accepted by",
    modifyTitle: "Modify Approved Quantity",
    approvedQty: "Approved Qty",
    saveNotify: "Save & Notify Customer",
    catalogTitle: "Products, Companies, Stock & Prices",
    catalogSub: "Control what dealers can see and order.",
    companiesTab: "companies",
    productsTab: "products",
    newCompanyPh: "New company / brand name",
    addCompany: "Add Company",
    productsCount: "Products",
    addedOn: "Added",
    visibleToCustomers: "Visible to Customers",
    allCompaniesFilter: "All companies",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    companyName: "Company",
    productName: "Product Name",
    productNamePh: "e.g. Urea (46% N)",
    callForRateHide: "Call for rate (hide price)",
    pricePerMt: "Price ₹/MT",
    stockMt: "Stock (MT)",
    minStockMt: "Low-stock alert (MT)",
    truckSizeMt: "Truck Size (MT)",
    productEnabled: "Enabled (visible to customers)",
    saveProduct: "Save Product",
    minCol: "Min (MT)",
    low: "LOW",
    customersTitle: "Customers",
    customersSub: "Dealer accounts, business history and outstanding amounts.",
    searchCustomers: "Search name / mobile...",
    ordersCountCol: "Orders",
    registeredCol: "Registered",
    businessHistory: "Business History",
    totalOrders: "Total Orders",
    totalPaid: "Total Paid",
    recentNotifs: "Recent Notifications to this customer",
    noneYet: "None yet.",
    reportsTitle: "Daily Records",
    reportsSub: "Day-wise record of sales, payments and stock — kept for every day, downloadable as Excel.",
    downloadExcel: "Download Excel",
    preparing: "Preparing...",
    ordersPlacedOn: "Orders placed on",
    salesByProduct: "Sales by Product",
    paymentsCollectedTitle: "Payments Collected",
    stockPosition: "Stock Position (current)",
    noOrdersDay: "No orders were placed on this day.",
    noProductMovement: "No product movement on this day.",
    noPaymentsDay: "No payments collected on this day.",
    time: "Time",
    method: "Method",
    qtyMt: "Qty (MT)",
    value: "Value",
    minLevelMt: "Min Level (MT)",
    lowRestock: "LOW — RESTOCK",
    settingsTitle: "Settings",
    settingsSub: "Notifications, admin accounts and gateway configuration.",
    adminAlertNumbers: "Admin Alert Mobile Numbers",
    adminMobile1: "Admin Mobile 1",
    adminMobile2: "Admin Mobile 2",
    upiIdLabel: "UPI ID for Customer QR Payments",
    businessNameLabel: "Business Name (shown in messages)",
    saveSettings: "Save Settings",
    mainAdmin: "Main Admin",
    adminRole: "Admin",
    you: "(you)",
    addAnotherAdmin: "Add Another Admin",
    adminNamePh: "Admin name",
    adminMobilePh: "Mobile (10 digits)",
    pinPh: "6-digit PIN",
    addAdmin: "Add Admin",
    addAdminNote: "The new admin logs in from the same portal with their mobile + OTP + this PIN. Share the PIN with them privately.",
    resetPin: "Reset PIN",
    remove: "Remove",
    added: "Added",
    role: "Role",
    allOrders: "All orders",
    disabled: "Disabled",
    edit: "Edit",
    ordersPlaced: "Orders Placed",
    salesValue: "Sales Value",
    storePhotos: "Our Store",
    shopWarehouse: "Our Shop & Warehouse",
    photosSub: "A glimpse of our shop, stock and dispatch at Mathabhanga-I Krishak Bazar.",
    mapTitle: "Find us on Google Maps",
    getDirections: "Get Directions",
    navHome: "Home",
    navBusiness: "Business Profile",
    navProducts: "Products",
    navContactUs: "Contact Us",
    navDealerLogin: "Dealer Login",
    wholesaleTag: "Wholesale Fertilizer Dealer",
    callNow: "Call Now",
    dealerLogin: "Dealer Login",
    introTitle: "Wholesale fertilizer supply for dealers & retailers",
    introText: "M/S Sabuj Sona Fertilizer is a wholesale fertilizer dealer supplying agricultural fertilizers in bulk to authorized dealers and retailers.",
    introNotGrocery: "This is NOT a home-delivery grocery service. We are a wholesale fertilizer business — purchases are made by licensed dealers for their shops.",
    whoFor: "For licensed dealers & retailers only",
    photoNotAvailable: "PHOTO NOT AVAILABLE",
    photoNotAvailableSub: "Genuine photo will be uploaded by the business",
    ourProducts: "Our Fertilizer Products",
    ourProductsSub: "Available fertilizer varieties from all major companies. Login to see live stock and rates.",
    availableTag: "Available",
    outOfStockTag: "Out of stock",
    businessDetails: "Business Details",
    store: "Store",
    location: "Location",
    district: "District",
    state: "State",
    pin: "PIN",
    country: "Country",
    aboutTitle: "About the business",
    aboutText: "M/S Sabuj Sona Fertilizer is a proprietorship business owned by Sonali Das Barman, authorized to wholesale fertilizers to retail dealers across Cooch Behar and West Bengal. We stock Urea, DAP, MOP/Potash, SSP and complex fertilizers from all major companies and arrange dispatch to your shop.",
    announcementLabel: "Announcement",
    bizContentTitle: "Business Content",
    bizContentSub: "Master Admin — everything you save here updates the public website instantly.",
    sectionIdentity: "Business Identity",
    sectionAddress: "Shop Address",
    sectionContacts: "Contact Numbers",
    sectionContent: "Website Content",
    sectionPhotos: "Business Photos",
    logoPhoto: "Business Logo",
    ownerPhoto: "Owner / Proprietor Photograph",
    shopPhotos: "Shop / Warehouse Photographs",
    uploadPhoto: "Upload Photo",
    deletePhoto: "Delete",
    confirmDeletePhoto: "Delete this photograph from the website?",
    savedOk: "Saved — the website is updated",
    reloadBiz: "Reload",
    mapsLinkLabel: "Google Maps Link",
    announcementPh: "Write an announcement for website visitors (optional)...",
    showAnnouncement: "Show announcement on website",
    contactNumbersLabel: "Contact Numbers (visitors can tap to call)",
    addContact: "Add another number",
    removeContact: "Remove",
    descriptionLabel: "Business Description",
    masterOnlyNote: "Only the Master Admin can change these settings. Please contact the Master Admin.",
    photosAdminTitle: "Shop & Proprietor Photos",
    photosAdminSub: "Upload genuine photos of the shop and the proprietor — they appear on the public website.",
    ourProprietor: "Our Proprietor",
    paymentSettings: "Payment Settings (shown to dealers)",
    paymentSettingsNote: "Dealers see this UPI ID, QR code and bank account when they tap Pay Online.",
    paymentQrLabel: "Payment QR Code",
    uploadQr: "Upload QR",
    bankAccountNumber: "Bank Account Number",
    bankName: "Bank Name",
    bankHolderName: "Bank Holder / Proprietor Name",
    quickNotice: "Notice / Service Call",
    quickAddress: "Shop Address",
    quickHelp: "Help & Support",
    noticeNone: "No new notices right now. Call us for today's rates and stock.",
    helpLogin: "Login problem? Try the OTP login, or call us for help.",
    helpDealer: "Dealer assistance is available on all working days.",
    comingPesticide: "Pesticide ordering",
    comingPayment: "Auto-verified online payment",
    comingSms: "Real SMS alerts on your phone",
    moreSoon: "More services are on the way.",
    backupNav: "Backup & Export",
    backupTitle: "Full Project Backup / Export",
    backupSub: "Master Admin only — full migration package for your own VPS.",
    masterOnlyFeature: "Only the Master Admin (9083169718) can see or use this feature.",
    createBackup: "Create Full Project Backup",
    backupConfirm: "Create a full project backup now? It packages source code, database, images and settings (no secrets).",
    creatingBackup: "Creating backup...",
    stepSource: "Collecting source code",
    stepDatabase: "Exporting database",
    stepAssets: "Copying uploaded images",
    stepDocs: "Writing documentation",
    stepVerify: "Verifying ZIP",
    backupReady: "Backup created successfully",
    downloadFull: "Download Full Backup",
    downloadDoc: "Download Documentation (PDF)",
    backupHistory: "Backup History",
    backupNameCol: "Backup Name",
    createdCol: "Created",
    sizeCol: "Size",
    filesCol: "Files",
    backupIncluded: "Included in this backup",
    backupExcluded: "Not included (with reasons)",
    deleteBackupConfirm: "Delete this backup permanently?",
    noBackups: "No backups yet. Create your first full backup above.",
    createFinalBackup: "Create Final Migration Backup (FULL_PROJECT_SOURCE_CODE_FINAL.zip)",
  },
  bn: {
    brandSub: "পাইকি পোর্টাল",
    dealerPortal: "ডিলার পোর্টাল",
    adminConsole: "অ্যাডমিন কনসোল",
    heroBadge: "লাইসেন্সযুক্ত ডিলারদের জন্য",
    heroTitle: "পশ্চিমবঙ্গের পাইকি সার অর্ডারিং পোর্টাল",
    heroSub: "ম/স সবুজ সোনা ফার্টিলাইজার রাজ্যজুড়ে লাইসেন্সযুক্ত ডিলারদের কাছে ইউরিয়া, ডিএপি, পটাশ ও অন্যান্য সার সরবরাহ করে। কোম্পানিভিত্তিক পাইকি অর্ডার করুন, প্রেরণ ট্র্যাক করুন এবং পেমেন্ট পরিচালনা করুন — সব এক পোর্টাল থেকে।",
    howTitle: "অর্ডারিং কীভাবে কাজ করে",
    how1: "আপনার নথিভুক্ত ডিলার মোবাইল নম্বর দিয়ে লগইন করুন।",
    how2: "কোম্পানি বাছুন, পণ্য বেছে কেজি, মেট্রিক টন বা ট্রাক-এ পরিমাণ লিখুন।",
    how3: "পছন্দের ডেলিভারি তারিখ দিয়ে অর্ডার নিশ্চিত করুন — কোম্পানি সঙ্গে সঙ্গে জানতে পারবে।",
    how4: "অনুমোদন, প্রেরণের গাড়ি ও পেমেন্ট অর্ডার ইতিহাসে ট্র্যাক করুন।",
    feature1Title: "সমস্ত প্রধান কোম্পানি",
    feature1Sub: "ইফকো, আইপিএল, ইন্দোরামা, কোরোমন্ডেল ও অন্যান্য — স্টক কোম্পানির তরফ থেকে লাইভ পরিচালিত।",
    feature2Title: "স্বচ্ছ পাইকি দর",
    feature2Sub: "প্রতি মেট্রিক টনের বর্তমান দর দেখুন, বা সর্বশেষ দর জানতে কলের অনুরোধ করুন।",
    feature3Title: "ডেলিভারি ট্র্যাকিং",
    feature3Sub: "প্রতিটি নিশ্চিত অর্ডারে গাড়ির নম্বর, প্রেরণের তারিখ ও ডেলিভারি অবস্থা জানানো হয়।",
    footerNote: "পাইকি সার বিক্রয় · পশ্চিমবঙ্গ",
    bpTitle: "ব্যবসার প্রোফাইল",
    bpSub: "কোচবিহার ও পশ্চিমবঙ্গজুড়ে ডিলারদের সেবা দেওয়া একটি প্রতিষ্ঠিত, লাইসেন্সযুক্ত পাইকি সার ব্যবসা।",
    bpWhoTitle: "লাইসেন্সযুক্ত পাইকি সার ডিলার",
    bpWhoText: "ম/স সবুজ সোনা ফার্টিলাইজার হল সোনালী দাস বর্মণের একমালিকানা ব্যবসা, খুচরো ডিলারদের কাছে সার পাইকি বিক্রির অনুমোদিত প্রতিষ্ঠান। আমরা সমস্ত প্রধান কোম্পানির ইউরিয়া, ডিএপি, এমওপি/পটাশ, এসএসপি ও জটিল সার মজুত রাখি এবং জেলাজুড়ে প্রেরণ করি।",
    legalName: "আইনগত নাম",
    tradeName: "ব্যবসার নাম",
    businessType: "ব্যবসার ধরন",
    proprietorship: "একমালিকানা",
    businessCategory: "ব্যবসার শ্রেণি",
    wholesaleDealer: "পাইকি সার ডিলার",
    licenseNo: "সার লাইসেন্স / অনুমোদন নং",
    udyamNo: "উদ্যম নিবন্ধন নং",
    gstin: "জিএসটিআইএন",
    storeAddress: "দোকানের ঠিকানা",
    trustNote: "নিশ্চিন্তে ব্যবসা করুন — আমাদের লাইসেন্স, উদ্যম নিবন্ধন ও জিএসটিআইএন জনসমক্ষে এবং যাচাইযোগ্য।",
    contactTitle: "যোগাযোগ করুন",
    contactSub: "আজকের দর, স্টক ও অর্ডারের জন্য এখনই কল করুন।",
    callNow: "কল করুন",
    visitStore: "দোকানে আসুন",
    welcomeBack: "স্বাগতম",
    howWouldYouLike: "আপনি কীভাবে লগইন করতে চান?",
    loginWithOtp: "OTP দিয়ে লগইন",
    loginWithPassword: "পাসওয়ার্ড দিয়ে লগইন",
    useDifferentNumber: "অন্য নম্বর ব্যবহার করুন",
    loginContinue: "লগইন / এগিয়ে যান",
    loginCardSub: "আপনার মোবাইল নম্বর দিন। অ্যাডমিন ও ডিলার অ্যাকাউন্ট স্বয়ংক্রিয়ভাবে চিহ্নিত হবে।",
    continue: "এগিয়ে যান",
    newCustomer: "নতুন কাস্টমার?",
    createDealerAccount: "ডিলার অ্যাকাউন্ট তৈরি করুন",
    verifyMobile: "মোবাইল যাচাই করুন",
    otpSentTo: "OTP পাঠানো হয়েছে",
    adminPinLabel: "অ্যাডমিন নিরাপত্তা পিন (৬ ডিজিট)",
    loginAsAdmin: "অ্যাডমিন হিসেবে লগইন",
    verifyLogin: "যাচাই করে লগইন",
    resendOtp: "আবার OTP পাঠান",
    changeNumber: "নম্বর বদলান",
    notRegisteredYet: "এখনও নথিভুক্ত নন",
    notRegisteredSub: "{m} নম্বরে কোনো অ্যাকাউন্ট নেই। অর্ডার করতে ডিলার অ্যাকাউন্ট তৈরি করুন।",
    createAccount: "অ্যাকাউন্ট তৈরি করুন",
    becomeDealer: "ডিলার হন",
    password: "পাসওয়ার্ড",
    login: "লগইন",
    useOtpInstead: "OTP দিয়ে লগইন করুন",
    registerTitle: "ডিলার অ্যাকাউন্ট তৈরি করুন",
    registerSub: "পাইকি সার অর্ডার করতে আপনার ব্যবসা নথিভুক্ত করুন।",
    backToLogin: "লগইনে ফিরুন",
    customerName: "গ্রাহক / ব্যবসার নাম",
    licensePh: "WB/FL/XXXXXX",
    posIdOptional: "পিওএস আইডি (ঐচ্ছিক)",
    passwordOptional: "পাসওয়ার্ড (ঐচ্ছিক — পাসওয়ার্ড লগইন চালু হবে)",
    passwordPh: "সর্বনিম্ন ৬ অক্ষর",
    addressLabel: "দোকান / ডেলিভারির ঠিকানা",
    addressPh: "গ্রাম, পোস্ট অফিস, জেলা, পিন",
    photoLabel: "গ্রাহকের ছবি / সেলফি",
    photoHint: "ছবি বা সেলফি আপলোড করুন (JPG/PNG, সর্বোচ্চ ৬ এমবি)",
    choosePhoto: "ছবি বাছুন",
    uploading: "আপলোড হচ্ছে...",
    sendOtpContinue: "OTP পাঠিয়ে এগিয়ে যান",
    sendingOtp: "OTP পাঠানো হচ্ছে...",
    creatingAccount: "অ্যাকাউন্ট তৈরি হচ্ছে...",
    dashboard: "ড্যাশবোর্ড",
    dashboardSubtitle: "আপনার পাইকি অর্ডার ও পেমেন্টের সারসংক্ষেপ।",
    fertilizer: "সার",
    pesticide: "কীটনাশক",
    myOrders: "আমার অর্ডার",
    profile: "প্রোফাইল",
    logout: "লগআউট",
    comingSoon: "শীঘ্রই আসছে",
    pendingApproval: "অনুমোদনের অপেক্ষায়",
    activeConfirmed: "সক্রিয় / নিশ্চিত",
    completed: "সম্পন্ন",
    outstandingDue: "বকেয়া",
    quickOrderFertilizer: "দ্রুত অর্ডার — সার",
    quickOrderFertilizerSub: "ইউরিয়া, ডিএপি, পটাশ ও অন্যান্য অর্ডার করুন",
    quickOrderPesticide: "দ্রুত অর্ডার — কীটনাশক",
    quickOrderPesticideSub: "কীটনাশক অর্ডারিং শীঘ্রই আসছে",
    recentOrders: "সাম্প্রতিক অর্ডার",
    viewAll: "সব দেখুন",
    selectCompany: "সার — কোম্পানি নির্বাচন করুন",
    selectCompanySub: "পণ্য ও স্টক দেখতে একটি কোম্পানি বেছে নিন।",
    viewProducts: "পণ্য দেখুন →",
    noCompanies: "এই মুহূর্তে কোনো কোম্পানি উপলব্ধ নেই।",
    allCompanies: "সব কোম্পানি",
    products: "পণ্য",
    searchFertilizer: "সার খুঁজুন...",
    product: "পণ্য",
    availableStock: "উপলব্ধ স্টক",
    ratePerMt: "দর (প্রতি মেট্রিক টন)",
    action: "পদক্ষেপ",
    outOfStock: "স্টক নেই",
    callForRate: "দর জানতে কল করুন",
    add: "যোগ করুন",
    addQuantity: "পরিমাণ যোগ করুন",
    available: "উপলব্ধ",
    quantity: "পরিমাণ",
    unit: "একক",
    kg: "কেজি",
    metricTon: "মেট্রিক টন",
    truck: "ট্রাক",
    lineTotal: "মোট",
    addToOrder: "অর্ডারে যোগ করুন",
    cancel: "বাতিল",
    productsInOrder: "টি পণ্য অর্ডারে আছে",
    viewRemove: "দেখুন / বাদ দিন",
    hide: "লুকান",
    reviewOrder: "অর্ডার পর্যালোচনা",
    orderReview: "অর্ডার পর্যালোচনা",
    orderReviewSub: "আপনার পাইকি অর্ডার দেখুন। পরিমাণ বদলাতে বা পণ্য বাদ দিতে পারেন।",
    requestedQty: "নির্ধারিত",
    approved: "অনুমোদিত",
    amount: "টাকা",
    proceedConfirm: "চূড়ান্ত নিশ্চিতকরণে এগিয়ে যান →",
    finalConfirmation: "চূড়ান্ত নিশ্চিতকরণ",
    productLines: "টি পণ্য · অর্ডার করার আগে যাচাই করুন।",
    deliveryRequiredDate: "ডেলিভারির পছন্দের তারিখ",
    note: "নোট",
    orderTotal: "মোট টাকা (দর-যুক্ত পণ্য)",
    noGstNote: "এই নিশ্চিতকরণে জিএসটি / ইনভয়েস নেই",
    back: "ফিরে যান",
    confirmOrder: "অর্ডার নিশ্চিত করুন",
    placingOrder: "অর্ডার হচ্ছে...",
    orderPlacedSuccess: "অর্ডার সফলভাবে হয়েছে",
    placedMsg: "আপনার নথিভুক্ত মোবাইলে নিশ্চিতকরণ পাঠানো হয়েছে। বর্তমান অবস্থা:",
    viewMyOrders: "আমার অর্ডার দেখুন",
    newOrder: "নতুন অর্ডার",
    emptyOrder: "আপনার অর্ডার খালি",
    emptyOrderSub: "অর্ডার করতে সার পণ্য যোগ করুন।",
    browseFertilizer: "সার দেখুন",
    myOrdersTitle: "আমার অর্ডার",
    myOrdersSub: "আপনার বর্তমান ও পূর্বের সমস্ত পাইকি অর্ডার।",
    orderNo: "অর্ডার নং",
    date: "তারিখ",
    total: "মোট",
    paid: "প্রদত্ত",
    due: "বকেয়া",
    payment: "পেমেন্ট",
    deliveryDate: "ডেলিভারির তারিখ",
    status: "অবস্থা",
    statusMethod: "অবস্থা / মাধ্যম",
    view: "দেখুন",
    cancelOrder: "অর্ডার বাতিল করুন",
    payOnline: "অনলাইনে পেমেন্ট করুন",
    deliveryDispatch: "ডেলিভারি / প্রেরণ",
    vehicleNumber: "গাড়ির নম্বর",
    driver: "ড্রাইভার",
    orderTimeline: "অর্ডার টাইমলাইন",
    ratePending: "দর বাকি",
    profileTitle: "প্রোফাইল",
    profileSub: "আপনার নথিভুক্ত ডিলার তথ্য।",
    editProfile: "প্রোফাইল সম্পাদনা",
    name: "নাম",
    mobileNumber: "মোবাইল নম্বর",
    addressLabelC: "ঠিকানা",
    posId: "পিওএস আইডি নম্বর",
    licenceNumber: "লাইসেন্স নম্বর",
    newPhotoReady: "নতুন ছবি প্রস্তুত — সংরক্ষণ করলে বসবে",
    changePhoto: "ছবি বদলান",
    newPassword: "নতুন পাসওয়ার্ড (না বদলাতে চাইলে খালি রাখুন)",
    saveChanges: "পরিবর্তন সংরক্ষণ করুন",
    profileUpdated: "প্রোফাইল হালনাগাদ হয়েছে",
    adminDashboardTitle: "অ্যাডমিন ড্যাশবোর্ড",
    adminDashboardSub: "অর্ডার, গ্রাহক ও প্রেরণের সামগ্রিক চিত্র।",
    newOrders: "নতুন অর্ডার",
    customers: "গ্রাহক",
    dispatch: "প্রেরণ",
    confirmedLabel: "নিশ্চিত",
    deliveredLabel: "পৌঁছে দেওয়া হয়েছে",
    cancelledLabel: "বাতিল",
    totalDue: "মোট বকেয়া",
    latestOrders: "সাম্প্রতিক অর্ডার",
    orders: "অর্ডার",
    productsStock: "পণ্য ও স্টক",
    dailyRecords: "দৈনিক হিসাব",
    annualReturns: "বার্ষিক সার",
    notifSettings: "নোটিফিকেশন সেটিংস",
    adminAccounts: "অ্যাডমিন অ্যাকাউন্ট",
    notifications: "নোটিফিকেশন",
    settings: "সেটিংস",
    adminOrdersTitle: "অর্ডার",
    adminOrdersSub: "আসা পাইকি অর্ডার দেখুন, অনুমোদন ও পরিচালনা করুন।",
    searchOrders: "অর্ডার নং / গ্রাহক খুঁজুন...",
    filterAll: "সব",
    filterOpen: "খোলা",
    customerLbl: "গ্রাহক",
    mobileLbl: "মোবাইল",
    reviewTitle: "অর্ডারের পণ্য — দেখুন, অনুমোদন, পরিবর্তন বা বাতিল করুন",
    preferredDelivery: "পছন্দের ডেলিভারি",
    customerNote: "গ্রাহকের নোট",
    ratePerMtShort: "দর / মেট্রিক টন",
    lineStatus: "লাইন অবস্থা",
    actions: "পদক্ষেপ",
    approve: "অনুমোদন",
    modify: "পরিবর্তন",
    paymentsTitle: "পেমেন্ট",
    recordPayment: "পেমেন্ট এন্ট্রি করুন",
    amountRupee: "টাকা ₹",
    refTxn: "রেফারেন্স / লেনদেন নং",
    noPaymentsYet: "এখনও কোনো পেমেন্ট এন্ট্রি নেই।",
    deliveryDispatchAdmin: "ডেলিভারি ও প্রেরণ",
    deliveryDateField: "ডেলিভারির তারিখ",
    driverName: "ড্রাইভারের নাম",
    driverPhone: "ড্রাইভারের ফোন",
    dispatchStatus: "প্রেরণ অবস্থা",
    notes: "নোট",
    saveDelivery: "ডেলিভারি তথ্য সংরক্ষণ করুন",
    activityTimeline: "কার্যক্রমের টাইমলাইন",
    by: "দ্বারা",
    acceptedBy: "অনুমোদন করেছেন",
    modifyTitle: "অনুমোদিত পরিমাণ পরিবর্তন",
    approvedQty: "অনুমোদিত পরিমাণ",
    saveNotify: "সংরক্ষণ ও গ্রাহককে জানান",
    catalogTitle: "পণ্য, কোম্পানি, স্টক ও দর",
    catalogSub: "ডিলাররা কী দেখবে ও কী অর্ডার করতে পারবে তা নিয়ন্ত্রণ করুন।",
    companiesTab: "কোম্পানি",
    productsTab: "পণ্য",
    newCompanyPh: "নতুন কোম্পানি / ব্র্যান্ডের নাম",
    addCompany: "কোম্পানি যোগ করুন",
    productsCount: "পণ্য",
    addedOn: "যোগ হয়েছে",
    visibleToCustomers: "গ্রাহকদের দেখা যাবে",
    allCompaniesFilter: "সব কোম্পানি",
    addProduct: "পণ্য যোগ করুন",
    editProduct: "পণ্য সম্পাদনা",
    companyName: "কোম্পানি",
    productName: "পণ্যের নাম",
    productNamePh: "যেমন ইউরিয়া (46% N)",
    callForRateHide: "দর জানতে কল (দর লুকান)",
    pricePerMt: "দর ₹/মেট্রিক টন",
    stockMt: "স্টক (মেট্রিক টন)",
    minStockMt: "লো-স্টক অ্যালার্ট (MT)",
    truckSizeMt: "ট্রাক মাপ (MT)",
    productEnabled: "চালু (গ্রাহকদের দেখা যাবে)",
    saveProduct: "পণ্য সংরক্ষণ করুন",
    minCol: "সর্বনিম্ন (MT)",
    low: "কম",
    customersTitle: "গ্রাহক",
    customersSub: "ডিলার অ্যাকাউন্ট, ব্যবসার ইতিহাস ও বকেয়া।",
    searchCustomers: "নাম / মোবাইল খুঁজুন...",
    ordersCountCol: "অর্ডার",
    registeredCol: "নথিভুক্ত",
    businessHistory: "ব্যবসার ইতিহাস",
    totalOrders: "মোট অর্ডার",
    totalPaid: "মোট প্রদত্ত",
    recentNotifs: "এই গ্রাহককে সাম্প্রতিক নোটিফিকেশন",
    noneYet: "এখনও নেই।",
    reportsTitle: "দৈনিক হিসাব",
    reportsSub: "দিন-ভিত্তিক বিক্রয়, পেমেন্ট ও স্টকের হিসাব — প্রতিদিনের রেকর্ড, এক্সেলে ডাউনলোডযোগ্য।",
    downloadExcel: "এক্সেল ডাউনলোড",
    preparing: "প্রস্তুত হচ্ছে...",
    ordersPlacedOn: "এই দিনে হওয়া অর্ডার",
    salesByProduct: "পণ্য অনুযায়ী বিক্রয়",
    paymentsCollectedTitle: "আদায় হওয়া পেমেন্ট",
    stockPosition: "বর্তমান স্টক অবস্থা",
    noOrdersDay: "এই দিনে কোনো অর্ডার হয়নি।",
    noProductMovement: "এই দিনে পণ্যের কোনো স্থানান্তর নেই।",
    noPaymentsDay: "এই দিনে কোনো পেমেন্ট আদায় হয়নি।",
    time: "সময়",
    method: "মাধ্যম",
    qtyMt: "পরিমাণ (MT)",
    value: "মূল্য",
    minLevelMt: "সর্বনিম্ন স্তর (MT)",
    lowRestock: "কম — স্টক ভরুন",
    settingsTitle: "সেটিংস",
    settingsSub: "নোটিফিকেশন, অ্যাডমিন অ্যাকাউন্ট ও গেটওয়ে কনফিগারেশন।",
    adminAlertNumbers: "অ্যাডমিন অ্যালার্ট মোবাইল নম্বর",
    adminMobile1: "অ্যাডমিন মোবাইল ১",
    adminMobile2: "অ্যাডমিন মোবাইল ২",
    upiIdLabel: "গ্রাহকের QR পেমেন্টের ইউপিআই আইডি",
    businessNameLabel: "ব্যবসার নাম (মেসেজে দেখানো হয়)",
    saveSettings: "সেটিংস সংরক্ষণ করুন",
    mainAdmin: "প্রধান অ্যাডমিন",
    adminRole: "অ্যাডমিন",
    you: "(আপনি)",
    addAnotherAdmin: "নতুন অ্যাডমিন যোগ করুন",
    adminNamePh: "অ্যাডমিনের নাম",
    adminMobilePh: "মোবাইল (১০ ডিজিট)",
    pinPh: "৬ ডিজিটের পিন",
    addAdmin: "অ্যাডমিন যোগ করুন",
    addAdminNote: "নতুন অ্যাডমিন একই পোর্টাল থেকে তাঁর মোবাইল + OTP + এই পিন দিয়ে লগইন করবেন। পিন ব্যক্তিগতভাবে জানান।",
    resetPin: "পিন রিসেট",
    remove: "সরান",
    added: "যোগ হয়েছে",
    role: "ভূমিকা",
    allOrders: "সব অর্ডার",
    disabled: "বন্ধ",
    edit: "সম্পাদনা",
    ordersPlaced: "অর্ডার হয়েছে",
    salesValue: "বিক্রয়ের মূল্য",
    storePhotos: "আমাদের দোকান",
    shopWarehouse: "আমাদের দোকান ও গুদান",
    photosSub: "মাথাভাঙা-১ কৃষক বাজারে আমাদের দোকান, স্টক ও প্রেরণের ঝলক।",
    mapTitle: "গুগল ম্যাপে আমাদের খুঁজুন",
    getDirections: "দিকনির্দেশ পান",
    navHome: "হোম",
    navBusiness: "ব্যবসার প্রোফাইল",
    navProducts: "পণ্য",
    navContactUs: "যোগাযোগ",
    navDealerLogin: "ডিলার লগইন",
    wholesaleTag: "পাইকি সার ডিলার",
    callNow: "কল করুন",
    dealerLogin: "ডিলার লগইন",
    introTitle: "ডিলার ও খুচরো বিক্রেতাদের জন্য পাইকি সার সরবরাহ",
    introText: "ম/স সবুজ সোনা ফার্টিলাইজার অনুমোদিত ডিলার ও খুচরো বিক্রেতাদের কাছে বাল্কে কৃষি সার সরবরাহকারী একটি পাইকি ব্যবসা।",
    introNotGrocery: "এটি বাড়িতে পণ্য পৌঁছে দেওয়ার দোকান নয়। আমরা পাইকি সার ব্যবসা — লাইসেন্সযুক্ত ডিলাররা তাঁদের দোকানের জন্য কেনেন।",
    whoFor: "শুধুমাত্র লাইসেন্সযুক্ত ডিলার ও খুচরো বিক্রেতাদের জন্য",
    photoNotAvailable: "ছবি উপলব্ধ নয়",
    photoNotAvailableSub: "প্রতিষ্ঠানের আসল ছবি পরে আপলোড করা হবে",
    ourProducts: "আমাদের সার পণ্য",
    ourProductsSub: "সমস্ত প্রধান কোম্পানির সার। লাইভ স্টক ও দর দেখতে লগইন করুন।",
    availableTag: "উপলব্ধ",
    outOfStockTag: "স্টক নেই",
    businessDetails: "ব্যবসার তথ্য",
    store: "দোকান",
    location: "অবস্থান",
    district: "জেলা",
    state: "রাজ্য",
    pin: "পিন",
    country: "দেশ",
    aboutTitle: "ব্যবসা সম্পর্কে",
    aboutText: "ম/স সবুজ সোনা ফার্টিলাইজার হল সোনালী দাস বর্মণের একমালিকানা ব্যবসা, কোচবিহার ও পশ্চিমবঙ্গের খুচরো ডিলারদের কাছে সার পাইকি বিক্রির অনুমোদিত প্রতিষ্ঠান। আমরা সমস্ত প্রধান কোম্পানির ইউরিয়া, ডিএপি, এমওপি/পটাশ, এসএসপি ও জটিল সার মজুত রাখি এবং আপনার দোকানে প্রেরণের ব্যবস্থা করি।",
    announcementLabel: "ঘোষণা",
    bizContentTitle: "ব্যবসার তথ্য পরিচালনা",
    bizContentSub: "মাস্টার অ্যাডমিন — এখানে সংরক্ষণ করলে ওয়েবসাইট সঙ্গে সঙ্গে হালনাগাদ হবে।",
    sectionIdentity: "ব্যবসার পরিচয়",
    sectionAddress: "দোকানের ঠিকানা",
    sectionContacts: "যোগাযোগের নম্বর",
    sectionContent: "ওয়েবসাইট কনটেন্ট",
    sectionPhotos: "ব্যবসার ছবি",
    logoPhoto: "ব্যবসার লোগো",
    ownerPhoto: "মালিকের ছবি",
    shopPhotos: "দোকান / গুদামের ছবি",
    uploadPhoto: "ছবি আপলোড করুন",
    deletePhoto: "মুছুন",
    confirmDeletePhoto: "এই ছবিটি ওয়েবসাইট থেকে মুছে ফেলবেন?",
    savedOk: "সংরক্ষিত — ওয়েবসাইট হালনাগাদ হয়েছে",
    reloadBiz: "রিলোড",
    mapsLinkLabel: "গুগল ম্যাপস লিংক",
    announcementPh: "দর্শনার্থীদের জন্য ঘোষণা লিখুন (ঐচ্ছিক)...",
    showAnnouncement: "ওয়েবসাইটে ঘোষণা দেখান",
    contactNumbersLabel: "যোগাযোগের নম্বর (ট্যাপ করলে কল হবে)",
    addContact: "আরেকটি নম্বর যোগ করুন",
    removeContact: "সরান",
    descriptionLabel: "ব্যবসার বিবরণ",
    masterOnlyNote: "এই সেটিংস শুধুমাত্র মাস্টার অ্যাডমিন পরিবর্তন করতে পারবেন। অনুগ্রহ করে মাস্টার অ্যাডমিনের সঙ্গে যোগাযোগ করুন।",
    photosAdminTitle: "দোকান ও মালিকের ছবি",
    photosAdminSub: "দোকান ও মালিকের আসল ছবি আপলোড করুন — এটি ওয়েবসাইটে দেখা যাবে।",
    ourProprietor: "আমাদের মালিক",
    paymentSettings: "পেমেন্ট সেটিংস (ডিলারদের দেখানো হয়)",
    paymentSettingsNote: "ডিলাররা অনলাইনে পেমেন্ট করার সময় এই ইউপিআই আইডি, QR কোড ও ব্যাংক অ্যাকাউন্ট দেখবেন।",
    paymentQrLabel: "পেমেন্ট QR কোড",
    uploadQr: "QR আপলোড",
    bankAccountNumber: "ব্যাংক অ্যাকাউন্ট নম্বর",
    bankName: "ব্যাংকের নাম",
    bankHolderName: "ব্যাংক হোল্ডার / মালিকের নাম",
    quickNotice: "নোটিশ / সার্ভিস কল",
    quickAddress: "দোকানের ঠিকানা",
    quickHelp: "সহায়তা",
    noticeNone: "এই মুহূর্তে নতুন কোনো নোটিশ নেই। আজকের দর ও স্টক জানতে কল করুন।",
    helpLogin: "লগইনে সমস্যা? OTP লগইন ব্যবহার করুন, বা সহায়তার জন্য কল করুন।",
    helpDealer: "সমস্ত কর্মদিবসে ডিলার সহায়তা পাওয়া যায়।",
    comingPesticide: "কীটনাশক অর্ডারিং",
    comingPayment: "স্বয়ংক্রিয় ভেরিফাইড অনলাইন পেমেন্ট",
    comingSms: "আপনার ফোনে আসল SMS অ্যালার্ট",
    moreSoon: "আরও পরিষেবা আসছে।",
    backupNav: "ব্যাকআপ ও এক্সপোর্ট",
    backupTitle: "সম্পূর্ণ প্রজেক্ট ব্যাকআপ / এক্সপোর্ট",
    backupSub: "শুধুমাত্র মাস্টার অ্যাডমিন — নিজের VPS-এর জন্য সম্পূর্ণ মাইগ্রেশন প্যাকেজ।",
    masterOnlyFeature: "শুধুমাত্র মাস্টার অ্যাডমিন (৯০৮৩১৬৯৭১৮) এই সুবিধা দেখতে বা ব্যবহার করতে পারবেন।",
    createBackup: "সম্পূর্ণ প্রজেক্ট ব্যাকআপ তৈরি করুন",
    backupConfirm: "এখনই সম্পূর্ণ প্রজেক্ট ব্যাকআপ তৈরি করবেন? এতে সোর্স কোড, ডাটাবেস, ছবি ও সেটিংস থাকবে (কোনো গোপন তথ্য নয়)।",
    creatingBackup: "ব্যাকআপ তৈরি হচ্ছে...",
    stepSource: "সোর্স কোড সংগ্রহ হচ্ছে",
    stepDatabase: "ডাটাবেস এক্সপোর্ট হচ্ছে",
    stepAssets: "আপলোড করা ছবি কপি হচ্ছে",
    stepDocs: "ডকুমেন্টেশন লেখা হচ্ছে",
    stepVerify: "ZIP যাচাই হচ্ছে",
    backupReady: "ব্যাকআপ সফলভাবে তৈরি হয়েছে",
    downloadFull: "সম্পূর্ণ ব্যাকআপ ডাউনলোড করুন",
    downloadDoc: "ডকুমেন্টেশন ডাউনলোড (PDF)",
    backupHistory: "ব্যাকআপ ইতিহাস",
    backupNameCol: "ব্যাকআপের নাম",
    createdCol: "তৈরি",
    sizeCol: "আকার",
    filesCol: "ফাইল",
    backupIncluded: "এই ব্যাকআপে আছে",
    backupExcluded: "অন্তর্ভুক্ত নয় (কারণসহ)",
    deleteBackupConfirm: "এই ব্যাকআপ স্থায়ীভাবে মুছে ফেলবেন?",
    noBackups: "এখনও কোনো ব্যাকআপ নেই। উপরে প্রথম ব্যাকআপ তৈরি করুন।",
    createFinalBackup: "চূড়ান্ত মাইগ্রেশন ব্যাকআপ তৈরি করুন (FULL_PROJECT_SOURCE_CODE_FINAL.zip)",
  },
};

const STATUS_BN = {
  "Order Placed": "অর্ডার হয়েছে",
  "Pending Approval": "অনুমোদনের অপেক্ষায়",
  "Under Review": "পর্যালোচনাধীন",
  "Quantity Modified": "পরিমাণ পরিবর্তিত",
  Confirmed: "নিশ্চিত",
  "Payment Pending": "পেমেন্ট বাকি",
  "Payment Completed": "পেমেন্ট সম্পন্ন",
  "Preparing for Delivery": "ডেলিভারির প্রস্তুতি চলছে",
  "Out for Delivery": "ডেলিভারিতে বেরিয়েছে",
  Delivered: "পৌঁছে দেওয়া হয়েছে",
  Cancelled: "বাতিল",
  Completed: "সম্পন্ন",
  Pending: "অপেক্ষমাণ",
  "Partially Paid": "আংশিক পরিশোধিত",
  Paid: "পরিশোধিত",
  "Rate Pending": "দর বাকি",
  Approved: "অনুমোদিত",
  Modified: "পরিবর্তিত",
  Requested: "নির্ধারিত",
  "Ready for Dispatch": "প্রেরণের জন্য প্রস্তুত",
  Dispatched: "প্রেরিত",
  verified: "যাচাইকৃত",
  pending: "অপেক্ষমাণ",
  "Item Approved": "পণ্য অনুমোদিত",
  "Item Cancelled": "পণ্য বাতিল",
  "Delivery Updated": "ডেলিভারি হালনাগাদ",
  "Payment Recorded": "পেমেন্ট এন্ট্রি",
  "Payment Received": "পেমেন্ট প্রাপ্ত",
  "Payment Verified": "পেমেন্ট যাচাইকৃত",
  "Order Updated": "অর্ডার হালনাগাদ",
  "Admin Removed": "অ্যাডমিন সরানো হয়েছে",
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sf_lang") || "en");
  useEffect(() => {
    localStorage.setItem("sf_lang", lang);
  }, [lang]);
  const t = (key, vars) => {
    let s = DICT[lang]?.[key] ?? DICT.en[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, v);
    return s;
  };
  const tAny = (text) => (lang === "bn" && STATUS_BN[text]) || text;
  const value = useMemo(() => ({ lang, setLang, t, tAny, isBn: lang === "bn" }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}

export function LangToggle({ className }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex rounded-full border border-slate-300 overflow-hidden text-xs font-bold ${className || ""}`} data-testid="lang-toggle">
      <button
        className={`px-2.5 py-1 transition-colors ${lang === "en" ? "bg-[#0B192C] text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}
        onClick={() => setLang("en")}
        data-testid="lang-en"
      >
        EN
      </button>
      <button
        className={`px-2.5 py-1 transition-colors ${lang === "bn" ? "bg-[#0B192C] text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}
        onClick={() => setLang("bn")}
        data-testid="lang-bn"
      >
        বাংলা
      </button>
    </div>
  );
}
